import { createFileRoute } from '@tanstack/react-router'
import { OrganizationsManagement } from '../../components/AdminOrganizations'

export const Route = createFileRoute('/admin/organizations')({
    component: () => (
        <OrganizationsManagement />
    ),
})

